import { SxProps } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const titleContainerSX: SxProps = {
	textAlign: 'center',
	width: '100%',
	position: 'relative',
};

export const titleLineSX: SxProps = {
	border: 'solid 1px',
	borderColor: 'grey.100',
	top: 'calc(50% - 1px)',
	left: 0,
	right: 0,
	zIndex: '-1',
	position: 'absolute',
};

export const titleSX: SxProps = {
	textAlign: 'center',
	color: 'primary.main',
	fontWeight: OpenSansFontWeights.light,
	fontSize: '36px',
	width: 'fit-content',
	margin: 'auto',
	backgroundColor: 'grey.50',
	padding: '0 10px',
	textTransform: 'uppercase',
};
